// Custom.js - Convertido de jQuery para vanilla JS

// Lazy loading de vídeos (já estava em vanilla JS)
document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  // Copy to clipboard function
  function copyToClipboard(element) {
    var temp = document.createElement("input");
    var oldValue = element.innerHTML;
    var spanContent = element.querySelector("span")?.innerHTML || "";

    document.body.appendChild(temp);
    temp.value = spanContent;
    temp.select();
    document.execCommand("copy");
    element.innerHTML = "COPIADO";
    setTimeout(function () {
      element.innerHTML = oldValue;
    }, 1000);
    temp.remove();
  }

  // Cupom click handler
  document.querySelectorAll("cupom").forEach(cupom => {
    cupom.addEventListener("click", function() {
      copyToClipboard(this);
    });
  });

  // Desktop account submenu
  const desktopAccountSubmenu = document.querySelector('.desktop-account-submenu');
  if (desktopAccountSubmenu) {
    desktopAccountSubmenu.addEventListener('click', (e) => {
      e.preventDefault();
      e.currentTarget.classList.toggle('open');
    });
  }

  // Product calculator
  if (document.body.classList.contains('template-product')) {
    const inputLargura = document.querySelector(".width-wrapper input");
    const botaoCalcular = document.querySelector(".calculator-container .button--primary");
    const resultTarget = document.getElementById("result-target");
    const targetText = document.getElementById("target-text");
    const inputQuantidade = document.querySelector(".form-input.quantity__input");
    const upsellButtons = document.querySelectorAll(".upsell-quantity .button");
    const selectAltura = document.querySelector(".calculator-container select");

    if (inputLargura) {
      inputLargura.addEventListener('input', function(e) {
        let value = e.target.value.replace(/[^\d,.]/g, '');

        const commaIndex = value.indexOf(',');
        const dotIndex = value.indexOf('.');

        if (commaIndex !== -1 && dotIndex !== -1) {
          if (commaIndex < dotIndex) {
            value = value.replace(/\./g, '');
          } else {
            value = value.replace(/,/g, '');
          }
        }

        if (value.length > 5) {
          value = value.substring(0, 5);
        }

        e.target.value = value;
      });
    }

    let quantidadeBase = 1;

    if (botaoCalcular) {
      botaoCalcular.addEventListener("click", function () {
        // Converte vírgula para ponto antes de fazer o parse
        const larguraValue = (inputLargura?.value || '0').replace(',', '.');
        const largura = parseFloat(larguraValue);

        if (isNaN(largura) || largura <= 0) {
          if (targetText) {
            targetText.textContent = "Por favor, insira um valor válido para a largura.";
            targetText.style.color = "red";
          }
          if (resultTarget) {
            resultTarget.classList.remove("calculated");
          }
          return;
        }

        // Lê a largura do rolo a partir do radio selecionado ("60 cm" → 0.60m | "1.22m" → 1.22m)
        // Fallback: data-divisor do metaobject de coleção (para produtos sem essa opção de variante)
        let divisor = Number(inputLargura?.dataset.divisor || 100) / 100;
        document.querySelectorAll('input[name="Largura do rolo"]').forEach(radio => {
          if (!radio.checked) return;
          const val = radio.value.replace(',', '.');
          const isCm = /cm/i.test(val);
          const num = parseFloat(val.replace(/[^0-9.]/g, ''));
          if (!isNaN(num) && num > 0) divisor = isCm ? num / 100 : num;
        });
        quantidadeBase = Math.ceil(largura / divisor);


        const panelSelectionContainer = document.getElementById('panel-selection-container');
        if (panelSelectionContainer) {
          const warningTarget = document.getElementById('warning-target');
          if (quantidadeBase <= (window?.quantidadeMaxima || Infinity)) {
            if (warningTarget) warningTarget.style.display = 'none';
            if (typeof Fancybox !== 'undefined') {
              Fancybox.show([{ src: '#panel-selection-container' }]);
            }
            const quantidadeEl = document.getElementById('quantidade');
            const quantidadeTotalEl = document.getElementById('quantidade-total');
            if (quantidadeEl) quantidadeEl.textContent = quantidadeBase;
            if (quantidadeTotalEl) quantidadeTotalEl.textContent = quantidadeBase;
            const selecionadosEl = document.querySelector('.selecionados');
            if (selecionadosEl) selecionadosEl.textContent = '0';
            document.querySelectorAll('.peca-input').forEach(input => {
              input.checked = false;
            });
            if (window?.selecionadas) window.selecionadas.clear();
          } else {
            if (warningTarget) warningTarget.style.display = 'block';
          }

          document.querySelectorAll('.product-form__buttons .button').forEach(btn => {
            btn.disabled = true;
          });
        } else {
          if (targetText) {
            targetText.innerHTML = `Você vai precisar de <strong>${quantidadeBase} ${quantidadeBase === 1 ? 'unidade' : 'unidades'}!</strong>`;

            targetText.style.color = "black";
          }
          if (resultTarget) {
            resultTarget.classList.add("calculated");
          }
          if (inputQuantidade) {
            inputQuantidade.value = quantidadeBase;
          }

          // Resetar seleção dos botões upsell
          upsellButtons.forEach(btn => btn.classList.remove("selected"));
        }

        // Upsell buttons handler
        upsellButtons.forEach(btn => {
          btn.addEventListener("click", function () {
            const text = this.textContent.replace("+", "").replace(" folha", "").replace("s", "");
            const extra = parseInt(text) || 0;

            if (this.classList.contains("selected")) {
              this.classList.remove("selected");
              if (inputQuantidade) inputQuantidade.value = quantidadeBase;
            } else {
              upsellButtons.forEach(b => b.classList.remove("selected"));
              this.classList.add("selected");
              if (inputQuantidade) inputQuantidade.value = quantidadeBase + extra;
            }
          });
        });

        // Select altura change handler
        if (selectAltura) {
          selectAltura.addEventListener("change", function () {
            const valorSelecionado = this.value;
            const radioInput = document.querySelector(`input[type='radio'][value='${valorSelecionado}']`);
            if (radioInput) radioInput.checked = true;
          });
        }
      });
    }
  }

  // Swatch color item click
  document.addEventListener('click', function(e) {
    const swatchItem = e.target.closest('.card .swatch-color-item');
    if (!swatchItem) return;

    e.preventDefault();

    const colorsSelector = swatchItem.closest('.colors-selector-card');
    if (colorsSelector) {
      colorsSelector.querySelectorAll('.active-swatch').forEach(el => {
        el.classList.remove('active-swatch');
      });
      swatchItem.classList.add('active-swatch');
    }

    const productItem = swatchItem.closest(".product-item");
    if (!productItem) return;

    const imgElement = productItem.querySelector('.card-media img:first-child');
    const imgSecondElement = productItem.querySelector('.card-media img + img');

    const newImageUrl = swatchItem.dataset.featured;
    const secondImageUrl = swatchItem.dataset.image;

    if (newImageUrl && imgElement) {
      imgElement.classList.add("loading");
      if (imgSecondElement) imgSecondElement.classList.add("loading");

      const tempImg1 = new Image();
      tempImg1.src = newImageUrl;
      tempImg1.onload = function () {
        imgElement.src = newImageUrl;
        imgElement.srcset = newImageUrl;
        imgElement.setAttribute("data-srcset", newImageUrl);
        imgElement.classList.remove("loading");
      };

      if (secondImageUrl && imgSecondElement) {
        const tempImg2 = new Image();
        tempImg2.src = secondImageUrl;
        tempImg2.onload = function () {
          imgSecondElement.src = secondImageUrl;
          imgSecondElement.srcset = secondImageUrl;
          imgSecondElement.setAttribute("data-srcset", secondImageUrl);
          imgSecondElement.classList.remove("loading");
        };
      }
    }
  });

  // Calculator container select
  const calculatorSelect = document.querySelector('.template-product .calculator-container .select__select');
  if (calculatorSelect) {
    calculatorSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const variantId = selectedOption?.dataset.variantId;
      if (variantId) {
        const radioInput = document.querySelector(`input[type='radio'][data-variant-id='${variantId}']`);
        if (radioInput) radioInput.checked = true;
      }
    });
  }

  // Upsell slider init
  window.upsellSliderInit = function () {
    // Swiper desativado a pedido do usuário - mantendo apenas rolagem nativa overflow-x
    /*
    const recommendContainer = document.querySelector('.recommend-container');
    if (!recommendContainer) return;

    const recommendSlider = recommendContainer.querySelector('.recommend-slider');
    if (!recommendSlider || recommendSlider.classList.contains('swiper-initialized')) return;

    const swiperWrapper = recommendSlider.querySelector('.swiper-wrapper');
    const slides = swiperWrapper ? swiperWrapper.querySelectorAll('.item-recommend') : [];

    if (slides.length > 0 && typeof Swiper !== 'undefined') {
      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 1,
          momentumBounce: true,
          momentumBounceRatio: 1,
          minimumVelocity: 0.02,
          sticky: false
        },
        scrollbar: false
      };

      new Swiper(recommendSlider, swiperConfig);
    }
    */

    // Inicializar Fancybox para modais de variantes (isso deve continuar funcionando)
    if (typeof Fancybox !== 'undefined') {
      const isCartPage = document.body.classList.contains('template-cart');
      const parentEl = isCartPage ? document.body : document.querySelector('.halo-cart-sidebar');

      Fancybox.bind("[data-fancybox*='upsell']", {
        dragToClose: false,
        parentEl: parentEl,
        closeButton: false
      });
    }

    const recommendContainer = document.querySelector('.recommend-container');
    if (recommendContainer) {
      recommendContainer.classList.add("loaded");
    }
  };

  function beforeSend(element) {
    const dropdownCart = document.getElementById("dropdown-cart");
    if (dropdownCart) dropdownCart.classList.add("updating-cart");
    const recommendBtn = element?.querySelector(".recommend-btn-add");
    if (recommendBtn) recommendBtn.classList.add("is-loading");
  }

  function afterSend(element) {
    const dropdownCart = document.getElementById("dropdown-cart");
    if (dropdownCart) dropdownCart.classList.remove("updating-cart");
    const recommendBtn = element?.querySelector(".recommend-btn-add");
    if (recommendBtn) recommendBtn.classList.remove("is-loading");
  }

  // Upsell form submit
  document.addEventListener("submit", function(e) {
    const form = e.target.closest(".upsell-form");
    if (!form) return;

    e.preventDefault();

    const formData = new FormData(form);
    const serializedData = {};
    formData.forEach((value, key) => {
      serializedData[key] = value;
    });
    const jsonData = JSON.stringify(serializedData);

    const addToCartUrl = (window.Shopify?.routes?.root || '/') + "cart/add.js";

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonData,
    };

    beforeSend(form);

    fetch(addToCartUrl, requestOptions)
      .then((response) => {
        afterSend(form);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Fechar Fancybox antes de atualizar o carrinho (como no backup)
        // Tentar fechar de múltiplas formas para garantir
        setTimeout(function() {
          const closeButton = document.querySelector('.custom-close-button');
          if (closeButton) {
            closeButton.click();
          }
          // Fallback: fechar Fancybox diretamente
          if (typeof Fancybox !== 'undefined' && Fancybox.close) {
            Fancybox.close();
          }
        }, 50);

        if (window.Shopify?.getCart && window.updateCart) {
          Shopify.getCart(window.updateCart);
        }
        document.body.classList.add("cart-sidebar-show");
      })
      .catch((error) => {
        if (typeof showWarning === 'function') {
          showWarning('Não foi possível adicionar este produto ao carrinho');
        }
        const closeButton = document.querySelector('.custom-close-button');
        if (closeButton) closeButton.click();
      });
  });

  // Variants product selects change
  document.addEventListener("change", function(e) {
    const select = e.target.closest(".variants-product-selects select");
    if (!select) return;

    const variantsContainer = select.closest(".variants-product-selects");
    if (!variantsContainer) return;

    const selects = Array.from(variantsContainer.querySelectorAll("select"));
    const currentIndex = selects.indexOf(select);
    const nextSelect = selects[currentIndex + 1];

    if (nextSelect && nextSelect.style.display === 'none' && nextSelect.querySelectorAll("option").length > 1) {
      nextSelect.style.display = '';
    } else {
      const selectedOptions = selects.map(s => s.value);
      const productDataEl = variantsContainer.querySelector("[data-json-product]");

      if (productDataEl) {
        const productData = JSON.parse(productDataEl.textContent);
        const matchingVariant = productData.find(function (variant) {
          return selectedOptions.every(function (option, index) {
            return variant.options[index] === option;
          });
        });

        const variantIdInput = variantsContainer.querySelector(".variantIdAddCart");
        const recommendBtn = variantsContainer.querySelector(".recommend-btn-add");

        if (matchingVariant && matchingVariant.available) {
          if (variantIdInput) variantIdInput.value = matchingVariant.id;
          if (recommendBtn) {
            recommendBtn.disabled = false;
            recommendBtn.value = "ADICIONAR";
          }
        } else {
          if (recommendBtn) {
            recommendBtn.disabled = true;
            recommendBtn.value = "ESGOTADO";
          }
        }
      }
    }

    // Scroll to recommend container
    const cartSidebar = document.querySelector(".halo-cart-sidebar");
    if (cartSidebar) {
      const container = cartSidebar.querySelector(".previewCart");
      const scrollTo = cartSidebar.querySelector(".recommend-container");

      if (container && scrollTo) {
        const scrollPosition = scrollTo.offsetTop + scrollTo.offsetHeight + container.scrollTop - container.offsetTop;
        container.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    }
  });
});
